import { ReactNode } from "react";
import { Space } from "antd";

function Toolbar({ children, style }: { children: ReactNode, style?: React.CSSProperties }) {
  return (
    <Space direction={"horizontal"} style={style}>
      {children}
    </Space>
  );
}

export default Toolbar;
